import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import Image from '@namia/image';
// import useSpan from '../../hooks/useSpan';
import Spacer from './Spacer';

const Img = (props) => {
  const {
    image: {
      src,
      srcset,
      placeholder,
      placeholderBase64,
      base64,
      width,
      height,
      alt,
    },
    description,
    size,
  } = props;
  // const currentSpan = useSpan(size);
  const colMd = {
    offset: size === 'main' ? 3 : 5,
    span: size === 'main' ? 16 : 11,
  };

  return (
    <>
      <Row>
        <Col
          xs={{
            offset: 2,
            span: 20,
          }}
          md={colMd}
        >
          <Image
            alt={alt}
            base64={base64}
            onError={() => {}}
            placeholder={placeholder}
            onLoad={() => {}}
            placeholderBase64={placeholderBase64}
            ratio={`${width}/${height}`}
            src={src}
            srcset={srcset}
          />
        </Col>
      </Row>
      {description && (
        <>
          <Spacer size="xs" />
          <Row>
            <Col
              xs={{
                offset: 2,
                span: 20,
              }}
              md={colMd}
            >
              <p className="caption">{description}</p>
            </Col>
          </Row>
        </>
      )}
      <Spacer size="md" />
    </>
  );
};

Img.defaultProps = {
  description: '',
};

Img.propTypes = {
  image: PropTypes.shape({
    description: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    srcset: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    base64: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    fields: PropTypes.shape.isRequired,
    placeholderBase64: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  description: PropTypes.string,
  size: PropTypes.string.isRequired,
};

export default Img;
